export default __webpack_public_path__ + "49557709f63e536405309a9a48c85e54.svg";